import React from "react";
import "./css/footer.css";

function CryptemberFooter() {

    return (
        <div className="footerCls w-100 d-flex align-items-center">

            <div className="col-1 col-md-1 mTop-1 d-flex justify-content-left"></div>

            <div className="col-3 col-md-3 mTop-1 d-flex justify-content-left">
                <img width="64"
                     height="64"
                     src="https://cryptember.com/wp-content/uploads/newlogo_black.png"
                     className="cryptember-logo"
                     alt="Cryptember Logo"/>
            </div>

            <div className="col-7 col-md-7 mTop-1">
                <div className="w-socials-section">
                    <div className="w-socials-list w-socials-list d-flex justify-content-end">

                        <div className="w-socials-item telegram">
                            <a className="w-socials-item-link"
                               rel="noopener nofollow"
                               target="_blank"
                               href="https://t.me/CryptemberOfficial"
                               title="Telegram"
                               aria-label="Telegram">
                            </a>
                        </div>

                        <div className="w-socials-item youtube">
                            <a className="w-socials-item-link"
                               rel="noopener nofollow"
                               target="_blank"
                               href="https://www.youtube.com/channel/UCixyUTOqPcaBekpIIc5b5sA"
                               title="YouTube"
                               aria-label="YouTube">
                            </a>
                        </div>

                        <div className="w-socials-item twitter">
                            <a className="w-socials-item-link"
                               rel="noopener nofollow"
                               target="_blank"
                               href="https://x.com/CryptemberBot"
                               title="Twitter"
                               aria-label="Twitter">
                            </a>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    );
}

export default CryptemberFooter;